import { Col, Container, Row, Stack } from "react-bootstrap";
import { useLocale } from "@/hooks/useLocale";
import LinkedIn from "@/assets/LinkedIn.svg";
import Telephone from "@/assets/Telephone.svg";
import Email from "@/assets/Email.svg";
import classes from "./styles.module.scss";
import clsx from "classnames";

export const TeamMemberPageContentSection = ({ className, item }) => {
  const locale = useLocale();
  const [forename] = item.name.split(" ");

  return (
    <div className={clsx(className, classes.member)}>
      <Container className="pb-5">
        <Row>
          <Col xs={12} lg={6}>
            <Stack className="flex-row pe-md-5" gap={4}>
              <div className={classes.member__follow}>
                <b>Connect with {forename}</b>
                <a href={item.linkedin} className={classes.linkedin} rel="nofollow" target="_blank">
                  <LinkedIn />
                </a>
              </div>
              <figure className="flex-grow-1 me-4 me-md-5">
                <img src={item.photo} alt="" />
              </figure>
            </Stack>
          </Col>
          <Col xs={12} lg={6} className="pt-md-5">
            {(item.telephone || item.email) && (
              <Stack
                className={clsx(classes.member__links, "flex-column flex-md-row mb-4 mb-md-5")}
                gap={{ xs: 0, md: 4 }}
              >
                {item.telephone && (
                  <a href={`tel:${item.telephone}`} className="p-3 flex-grow-1">
                    <dl>
                      <dt className="me-3">
                        <Telephone />
                      </dt>
                      <dd>{item.telephone}</dd>
                    </dl>
                  </a>
                )}
                {item.email && (
                  <a href={`mailto:${item.email}`} className="p-3 flex-grow-1">
                    <dl>
                      <dt className="me-3">
                        <Email />
                      </dt>
                      <dd dangerouslySetInnerHTML={{ __html: `Email ${forename}` }}></dd>
                    </dl>
                  </a>
                )}
              </Stack>
            )}
            <div className="me-4 mb-5" dangerouslySetInnerHTML={{ __html: item[`description_${locale}`] }} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
